import type { ReactNode, RefObject } from 'react'
import React from 'react'
import type { OverlayProps, PopoverProps } from 'react-bootstrap'
import { Overlay, Popover } from 'react-bootstrap'

export type BasePopoverProps = {
  show: boolean
  setShow: (value: boolean) => void
  target: OverlayProps['target']
  placement?: PopoverProps['placement']
  name: string
  children: ReactNode
  header?: ReactNode
  focusRef?: RefObject<HTMLElement>
  container?: OverlayProps['container']
}
export const BasePopover = ({
  show,
  setShow,
  target,
  placement = 'right',
  name,
  children,
  header,
  focusRef,
  container,
}: BasePopoverProps) => {
  const onHide = () => setShow(false)

  // A synchronously autofocused input scrolls itself into view while Popper still holds the overlay at its
  // pre-measurement position, so focus only the handed element after the overlay has entered and been positioned.
  const onEntered: OverlayProps['onEntered'] = () => {
    focusRef?.current?.focus({ preventScroll: true })
  }

  return (
    <Overlay
      show={show}
      target={target}
      placement={placement}
      rootClose={true}
      onHide={onHide}
      onEntered={onEntered}
      container={container}
    >
      <Popover id={`${name}-pop-over`} className="fw-normal fs-5 shadow-lg">
        <Popover.Header>{header}</Popover.Header>
        <Popover.Body style={{ width: '350px', maxHeight: '80vh', overflow: 'auto' }}>{children}</Popover.Body>
      </Popover>
    </Overlay>
  )
}
